import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-investment-menu',
  templateUrl: './investment-menu.component.html',
  styleUrls: ['./investment-menu.component.css']
})
export class InvestmentMenuComponent implements OnInit {
  menuList:any;
  pageList:any;

  constructor() { }

  ngOnInit() {
    this.menuList=localStorage.getItem('menuList');
    this.menuList=JSON.parse(this.menuList);
    for(let i=0; i<this.menuList.length; i++){
      if(this.menuList[i].KHB_MenuName=='Investment')
        this.pageList=this.menuList[i].KHB_PagesList;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/investment/investment-menu/investment-menu.component.ts